class VideoSlide extends HTMLElement {
  static observedAttributes = ["playing"];

  constructor() {
    super();

    this.video = this.querySelector("video");

    // this.addEventListener("click", (event) => {
    //   Theme.Helpers.toggle_attribute(this, "playing");
    // });

    this.video.addEventListener("ended", (event) => {
      this.stop();
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.stop();
        }
      });
    });

    observer.observe(this);
  }

  play() {
    this.setAttribute("playing", true);
  }

  stop() {
    this.removeAttribute("playing");
  }

  attributeChangedCallback(attribute, value1, value2) {
    if (attribute == "playing" && value2 == "true") {
      this.video.play();
    }

    if (attribute == "playing" && value2 == null) {
      this.video.pause();
    }
  }
}

customElements.define("video-slide", VideoSlide);
